<template>
	<div class="edit_wrap">
		<!-- tab -->
		<div class="add_top">
			<div class="add_tab active_tab">品牌详情</div>
		</div>
		
		<!-- 品牌详情 -->
		<div class="choice_brand mt20 mb20">
			<div class="ml100 mt10" style="font-size: 10px"  v-if="hasSelBrand == 1 && brandDetail.brandId==0">
				<span class="main_word">以下是供应商新添加的品牌，请检查ECShop品牌列表是否已有该品牌。如果有请选择大V店已有的品牌。如果没有请采销先在ECShop添加需要的品牌信息</span>
			</div>
			<!-- 中英文名称 -->
			<div class="add_name">
				<div class="c_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌中文名称：</span>
					<span class="f999 f12">{{brandDetail.brandName}}</span>
					<span class="main_word"  v-if="snapshot.brandName">&nbsp;&nbsp; {{ snapshot.brandName }}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌英文名称：</span>
					<span class="f999 f12">{{brandDetail.brandEnname}}</span>
					<span class="main_word" v-if="snapshot.brandEnname">&nbsp;&nbsp; {{ snapshot.brandEnname }}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌介绍：</span>
					<span class="f999 f12">{{brandDetail.brandDesc}}</span>
					<span class="main_word" v-if="snapshot.brandDesc">&nbsp;&nbsp; {{ snapshot.brandDesc }}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">重点商品：</span>
					<span class="f999 f12">{{brandDetail.brandGoodsDesc}}</span>
					<span class="main_word" v-if="snapshot.brandGoodsDesc">&nbsp;&nbsp; {{ snapshot.brandGoodsDesc }}</span>
				</div>
				<div class="e_name">
					<!-- <span class="main_word mr4">*</span> -->
					<span class="form_color">品牌合作品类：</span>
					<span v-for="category in brandDetail.supplierApplyBrandCategories" class="f999 f12">{{category.categoryName}};&nbsp;&nbsp;</span>
				</div>
				<div class="e_name" v-if="hasSelBrand == 1 && brandDetail.brandId==0">
					<span class="form_color">选择大V已录入的品牌：</span>
					<template>
						<el-select v-model="brandId" filterable remote
								   placeholder="请输入关键词"
								   :remote-method="initBrandList"
								   :loading="loading">
							<el-option
									v-for="item in options"
									:key="item.brandId"
									:label="item.brandName"
									:value="item.brandId">
							</el-option>
						</el-select>
					</template>

				</div>
				<p></p>
				<div class="ml150 mt10" v-if="hasSelBrand == 1 && brandDetail.brandId==0">
					<span class="main_word">如果大V服务平台还没有该品牌，请现在ECShop添加要用的品牌信息</span>
				</div>
			</div>
			<!-- 信息验证 -->
			<div v-if="brandDetail.categoryIsBook != 1">
				<el-form :model="brandDetail" label-width="207px" class="demo-ruleForm">
					<!-- 商品是否进口 -->
					<el-form-item label="商品是否进口：">
						<span v-if="brandDetail.goodsType == 1" class="f999 f12">非进口</span>
						<span v-if="brandDetail.goodsType == 2" class="f999 f12">进口</span>
						<span class="main_word" v-if="snapshot.goodsType == 1">&nbsp;&nbsp; 非进口</span>
						<span class="main_word" v-if="snapshot.goodsType == 2">&nbsp;&nbsp; 进口</span>
					</el-form-item>

					<!-- 品牌经营方式 -->
					<el-form-item label="品牌经营方式：">
						<span v-if="brandDetail.businessType == 1" class="f999 f12">自有品牌</span>
						<span v-if="brandDetail.businessType == 2" class="f999 f12">代理商</span>
						<span v-if="brandDetail.businessType == 3" class="f999 f12">其他</span>
						<span class="main_word" v-if="snapshot.businessType == 1">&nbsp;&nbsp; 自有品牌</span>
						<span class="main_word" v-if="snapshot.businessType == 2">&nbsp;&nbsp; 代理商</span>
						<span class="main_word" v-if="snapshot.businessType == 3">&nbsp;&nbsp; 其他</span>
					</el-form-item>
					<!-- 商标注册证电子版 -->
					<el-form-item v-if="brandDetail.businessType == 1 || brandDetail.businessType == 2"
								  label="商标注册证电子版：" prop="trademarkRegistrationCertificateFile">
						<div>
							<img @click="previewPic($event)" v-for="rcFile in brandDetail.trademarkRegistrationCertificateFile.split(',')"
								 class="pic_skan" :src="rcFile">
							<img @click="previewPic($event)" class="pic_skan_red"
								 v-for="srcFile in snapshot.trademarkRegistrationCertificateFile.split(',')"
								 v-if="srcFile" :src="srcFile">
						</div>
					</el-form-item>
					<!-- 完整授权链证书电子版 -->
					<el-form-item v-if="brandDetail.businessType == 1 || brandDetail.businessType == 2"
								  label="完整授权链证书电子版：" prop="authCertificateFile">
						<div>
							<img @click="previewPic($event)" v-for="acFile in brandDetail.authCertificateFile.split(',')" class="pic_skan"
								 :src="acFile">
							<img @click="previewPic($event)" class="pic_skan_red" v-for="sacFile in snapshot.authCertificateFile.split(',')"
								 v-if="sacFile" :src="sacFile">
						</div>
					</el-form-item>
					<!-- 订货单电子版 -->
					<el-form-item v-if="brandDetail.businessType == 3" label="订货单电子版：" prop="purchaseOrderFile">
						<div>
							<img @click="previewPic($event)" v-for="poFile in brandDetail.purchaseOrderFile.split(',')" class="pic_skan"
								 :src="poFile">
							<img @click="previewPic($event)" class="pic_skan_red" v-for="spoFile in snapshot.purchaseOrderFile.split(',')"
								 v-if="spoFile" :src="spoFile">
						</div>
					</el-form-item>
					<!-- 报关单扫描件 -->
					<el-form-item v-if="brandDetail.goodsType == 2" v-show="(brandDetail.customsDeclarationFormFile.split(',').length > 0 && brandDetail.customsDeclarationFormFile.split(',')[0]!='')" label="报关单扫描件：" prop="customsDeclarationFormFile">
						<div>
							<img @click="previewPic($event)" v-for="cdfFile in brandDetail.customsDeclarationFormFile.split(',')" class="pic_skan"
								 :src="cdfFile">
							<img @click="previewPic($event)" class="pic_skan_red" v-for="scdfFile in snapshot.customsDeclarationFormFile.split(',')"
								 v-if="scdfFile" :src="scdfFile">
						</div>
					</el-form-item>

					<!-- 质检单电子版 -->
					<el-form-item
							v-if="brandDetail.registeredCountry==1 && brandDetail.goodsType == 1 && (brandDetail.businessType == 1 || brandDetail.businessType == 2)"
							label="质检单电子版：" prop="qualityInspectionFile">
						<div>
							<img @click="previewPic($event)" v-for="qiFile in brandDetail.qualityInspectionFile.split(',')" class="pic_skan"
								 :src="qiFile">
							<img @click="previewPic($event)" class="pic_skan_red" v-for="sqiFile in snapshot.qualityInspectionFile.split(',')"
								 v-if="sqiFile" :src="sqiFile">
						</div>
					</el-form-item>
					<!-- 入境货物检验检疫证明 -->
					<el-form-item v-if="brandDetail.goodsType == 2" v-show="(brandDetail.inspectionQuarantineFile.split(',').length > 0 && brandDetail.inspectionQuarantineFile.split(',')[0]!='')" label="入境货物检验检疫证明：" class="dib"
								  prop="inspectionQuarantineFile">
						<div>
							<img @click="previewPic($event)" v-for="iqFile in brandDetail.inspectionQuarantineFile.split(',')" class="pic_skan"
								 :src="iqFile">
							<img @click="previewPic($event)" class="pic_skan_red" v-for="siqFile in snapshot.inspectionQuarantineFile.split(',')"
								 v-if="siqFile" :src="siqFile">
						</div>
					</el-form-item>
					<!-- 质检日期 -->
					<el-form-item
							v-if="brandDetail.registeredCountry==1 && brandDetail.goodsType == 1 && (brandDetail.businessType == 1 || brandDetail.businessType == 2)"
							label="质检日期：" prop="qualityInspectionDate">
						{{ brandDetail.qualityInspectionDate | time}}
						<span class="main_word"
							  v-if="snapshot.qualityInspectionDate">&nbsp;&nbsp; {{ snapshot.qualityInspectionDate | time
							}}</span>
					</el-form-item>
				</el-form>
			</div>
			<!-- 保存 -->
			<div class="w140 auto mt120">
				<el-button  v-if="hasSelBrand == 1 && brandDetail.brandId==0" type="primary" @click="saveBrandRelation">保存</el-button>
				<el-button type="primary" @click="reback()">返回</el-button>
			</div>
			<!--预览图片-->
			<el-dialog :visible.sync="dialogVisible" size="small">
				<img  width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>

	</div>
</template>

<script type="text/javascript">
	export default {
		data () {
			return {
                loading:false,
				// 图片预览
				dialogImageUrl: '',			
        		dialogVisible: false,
				isChoice: true,				// tab 当前页面
				search_result: false,		// 搜索结果弹框
				brand_key: '',			// 品牌关键字搜索
				radio: null,							// 选中的内容,
                options: [],
				hasSelBrand:0,
                brandId:'',
                brandApplyId : 0,
                status : 0,                                        // 申请状态,Integer
				// 非图书 申请品牌信息
				brandDetail: {
					brandApplyId:  0,                                // 品牌申请id,Integer
					supplierApplyId :  0,                             // 供应商申请id,Integer
                    brandId:0,                                         // brandId
					brandName :  "",                                 // 品牌名称,String
					brandEnname :  "",                              // 英文名称,String
					brandDesc :  "",                          // 品牌介绍,String
					brandGoodsDesc :  "",                            // 重点商品介绍,String
					categoryIsBook : 0,                                // 品类是否为图书,Integer：0否，1是
					registeredCountry : 0,                             // 注册国家,Integer：1中国
					businessType :  0,                                  // 经营方式（1：自有品牌 2：代理商 3：其他）
					goodsType :  0,                                     // 商品类型（1：非进口 2：进口）
					trademarkRegistrationCertificateFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",                    // 商标注册电子版,String
					purchaseOrderFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",                      // 订货单电子版,String
					authCertificateFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",              // 完整授权链证书电子版,String
					qualityInspectionFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",             // 质检单电子版,String
					qualityInspectionDate : 1493281320,                       // 质检日期
					customsDeclarationFormFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",       // 报关单
					inspectionQuarantineFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",          // 入境货物检验检疫证明,String
					taxFormFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",                              // 税单扫描件,String
					goodsFormFile :  "http://img1.bravetime.net/supplier/2017/05/17/400_400_7a569739afab5f9405d9b934df240a4a.jpg",                          // 商品清单扫描件,String
				},
                snapshot: {
                    trademarkRegistrationCertificateFile :  "",                    // 商标注册电子版,String
                    purchaseOrderFile :  "",                      // 订货单电子版,String
                    authCertificateFile :  "",              // 完整授权链证书电子版,String
                    qualityInspectionFile :  "",             // 质检单电子版,String
                    customsDeclarationFormFile :  "",       // 报关单
                    inspectionQuarantineFile :  "",          // 入境货物检验检疫证明,String
                    taxFormFile :  "",                              // 税单扫描件,String
                    goodsFormFile :  "",                          // 商品清单扫描件,String
				}
			}
		},
		mounted () {
            var brandApplyId = this.$route.query.brandApplyId;
            if(this.$route.query.hasSelBrand) {
                this.hasSelBrand = this.$route.query.hasSelBrand;
            }
            this.brandApplyId = brandApplyId;
            if(brandApplyId){
                this.initBrandDetail(brandApplyId);
			}
		},

		methods: {
            initBrandList(query) {
                var that = this;
                if (query !== '') {
					/*获取品牌数据*/
                    $.get({
                        url: '/suppliers/supplierSettled/findBrandByKeyword',
                        dataType: "json",
                        data: {brandName:query},
                        success: function (result) {
                            if (!result.code) {
                                that.options = result.data.list;
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        },
                        error : function (err) {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    });
                }
			},

			// 预览图片
			previewPic (e) {
				console.log(e)
				this.dialogVisible = true;
				// 获取当前图片地址
				this.dialogImageUrl = e.currentTarget.src;
			},

            /**
			 * 保存品牌关联关系
             */
            saveBrandRelation () {
                var that = this;
                if (!that.brandId) {
                    this.$message.error('请选择品牌');
                    return;
				}
				if(!that.brandApplyId) {
                    this.$message.error('申请的品牌信息有误');
                    return;
                }

                $.get({
                    url: '/suppliers/supplierSettled/brand/update',
                    dataType: "json",
                    data: {
                        applyBrandId : that.brandApplyId,
                        brandId : that.brandId
					},
                    success: function (result) {
                        if (!result.code) {
                            that.$alert('品牌保存成功', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    window.opener.eventHub.$emit('reloadBrandList',null);
                            		window.close();
//                                    that.$router.push({
//                                        path: '/auditBrandDetail?brandApplyId=' + that.brandApplyId
//                                    });
//                                    that.hasSelBrand = 0;
//                                    that.initBrandDetail();
                                }
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                });
			},

            // 切换tab页
            choiceTab () {
                this.isChoice = true;
                $('.add_tab:eq(0)').addClass('active_tab').siblings().removeClass('active_tab');
            },
            addTab () {
                this.isChoice = false;
                $('.add_tab:eq(1)').addClass('active_tab').siblings().removeClass('active_tab');
            },

            initBrandDetail(brandApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/supplierSettled/findSupplierApplyBrandAndSnapshot',
                    data: {
                        brandApplyId: brandApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.brandDetail = result.data.lastest;
                            that.snapshot = result.data.snapshot;
                            if (that.brandDetail.brandId) {
                                that.brandId = that.brandDetail.brandId;
							} else {
                                that.brandId = '';
                            }
                            that.status = that.brandDetail.status;
                            //初始化品牌列表
                            /*if(that.hasSelBrand == 1 && that.brandDetail.brandId==0) {
                                that.initBrandList();
                            }*/
                            if(that.snapshot) {
                                    if(!that.snapshot.trademarkRegistrationCertificateFile){
                                        that.snapshot.trademarkRegistrationCertificateFile = "";
									}
                                if(!that.snapshot.purchaseOrderFile){
                                    that.snapshot.purchaseOrderFile = "";
                                }
                                if(!that.snapshot.authCertificateFile){
                                    that.snapshot.authCertificateFile = "";
                                }
                                if(!that.snapshot.qualityInspectionFile){
                                    that.snapshot.qualityInspectionFile = "";
                                }
                                if(!that.snapshot.customsDeclarationFormFile){
                                    that.snapshot.customsDeclarationFormFile = "";
                                }
                                if(!that.snapshot.inspectionQuarantineFile){
                                    that.snapshot.inspectionQuarantineFile = "";
                                }
                                if(!that.snapshot.taxFormFile){
                                    that.snapshot.taxFormFile = "";
                                }
                                if(!that.snapshot.goodsFormFile){
                                    that.snapshot.goodsFormFile = "";
                                }
                            }
                        } else {

                        }
                    }
                })
            },
			reback(){
                //history.go(-1);
                window.close();
			}
		},
		computed: {
			amount: function () {
				return 200 - this.addForm.brandDesc.length;
			}
		}
	}

</script>

<style type="text/css" lang="less" scoped>
	.edit_wrap {
		width: 1050px;
	  // height: 4000px;
	  margin: 50px auto;
	  border: 1px solid #eee;
	  .add_top {
	  	width: 100%;
	  	height: 40px;
	  	background-color: #f9f9f9;
	  }
	  .add_tab {
	  	display: inline-block;
	  	width: 170px;
	  	height: 40px;
	  	text-align: center;
	  	line-height: 40px;
	  	color: #666;
	  	font-size: 14px;
	  	cursor: pointer;
	  }
	  .active_tab {
	  	border-bottom: 1px solid #ff4a7d;
	  	color: #ff4a7d;
	  }
	  .add_name {
	  	padding-left: 96px;
	  }
	}
	.choice_brand {
		min-height: 400px;
	}
	.w500 {
		width: 500px;
	}
	.w250 {
		width: 250px;
	}
	.w165 {
		width: 165px;
	}
	.radio_group {
		width: 90%;
		padding-left: 15%;
		max-height: 150px;
		overflow-y: scroll;
	}
	.list_radio {
		margin-top: 10px;
		margin-left: 10%;
		width: 40%;
		overflow: hidden; 
		text-overflow:ellipsis; 
		white-space: nowrap;
	}
	.mt120 {
		margin-top: 120px;
	}
	.result_radio .el-radio + .el-radio {
     margin-left: 10%; 
	}
	.dialog-footer {
		text-align: center;
	}
	.form_color {
		color: rgb(106, 72, 77);
	}
	.c_name, .e_name {
		line-height: 36px;
	}
	.el-form-item {
		margin-bottom: 0;
	}
	.pic_skan {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 1px solid #c0ccda;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.pic_skan_red {
		width: 150px;
		height: 150px;
		margin-top: 5px;
		border: 2px solid #ff4a7d;
		border-radius: 6px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.ml150 {
		margin-left: 150px;
	}
	.ml100 {
		margin-left: 100px;
	}
	.w140{
		width: 140px;
	}
</style>


// WEBPACK FOOTER //
// brandDetail.vue?2244cf48